/*
  Data Management module State.
*/

import * as entityUtils from '@/core/utils/entityUtils';

/** Template Table schema. */
export const SCHEMA_INITIAL_DATA = entityUtils.SCHEMA_INITIAL_DATA;

/** Template Field definition. */
export const FIELD_INITIAL_DATA = entityUtils.FIELD_INITIAL_DATA;

export function getFieldInitialData() {
  const field = JSON.parse(JSON.stringify(FIELD_INITIAL_DATA));
  if (['select', 'create_date', 'update_date'].includes(field.type)) {
    field.data.options = [];
  }
  return field;
}

export const SYSTEM_MODULE_MAPPING = {
  mdmModel: {
    name: 'MdmModel',
    weight: 1,
    permission: 'read',
    path: '/app/mdm-model',
  },
  toDoList: {
    name: 'todo-list',
    weight: -1,
    permission: 'write',
    uuid: 'Todo List',
    path: '/app/todolist',
  },
  // Add path to Job Queue as child of Monitoring module
  monitoring: {
    name: 'Monitoring',
    text: 'Monitoring',
    weight: 100,
    uuid: 'Monitoring',
    permission: 'read',
    icon: 'chart-bar',
    children: [
      {
        path: '/monitoring/file-logs',
        type: 'fileLogs',
        // text: 'File Logs',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
      {
        path: '/monitoring/job-queue', 
        type: 'jobQueue',
        // text: 'Job Queue',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
    ],
  },
  connectors: {
    name: 'connector-screen',
    weight: 0,
    permission: 'write',
    path: '/app/connector-screen',
  },
  systemInfo: {
    name: 'Administration',
    text: 'System Info',
    uuid: 'System Info',
    permission: 'read',
    weight: 101,
    icon: 'info-circle',
    children: [
      {
        path: '/administration/users',
        type: 'userSecurity',
        // text: 'User Security',
        weight: 1,
        // icon: ['fas', 'user-shield']
      },
      {
        path: '/administration/audit-log',
        type: 'auditLog',
        // text: 'Audit Log',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
      {
        path: '/administration/system-settings',
        type: 'systemSettings',
        // text: 'Audit Log',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
      {
        path: '/administration/global',
        type: 'globalPermissions',
        // text: 'Audit Log',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
      {
        path: '/administration/custom-navigation',
        type: 'customNavigation',
        // text: 'Audit Log',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
    ],
  },
  fileManipulation: {
    name: 'File Manipulation',
    text: 'File Manipulation Controller',
    weight: 100,
    uuid: 'File Manipulation Controller',
    permission: 'read',
    icon: 'file',
    children: [
      {
        path: '/file-manipulation/storage-list',
        type: 'FTPStorageList',
        // text: 'FTP Storage List',
        weight: 1,
        // icon: ['fas', 'cloud']
      },
      {
        path: '/file-manipulation/batch-file',
        type: 'batchFile',
        // text: 'Batch File',
        weight: 1,
        // icon: ['fas', 'clipboard-list']
      },
      {
        path: '/file-manipulation/batch-endpoint',
        type: 'batchEndpoint',
        // text: 'Batch Endpoint',
        weight: 1,
        // icon: ['fas', 'code-branch']
      },
    ],
  },
  loanCalculator: {
    name: 'loan-calculator',
    weight: 0,
    permission: 'write',
    path: '/app/loan-calculator',
  },
  sunModel: {
    name: 'graph',
    weight: 0,
    permission: 'read',
    path: '/app/sunmodel',
  },
  orchestration: {
    name: 'Orchestration',
    weight: 0,
    permission: 'read',
    path: '/app/orchestration',
  },
};

const STATE = {
  multiselectRefs: {},
  pagedDataLookups: null,
  defaultOptions: null,
  editRowSections: {
    form: null,
    isModalOpened: false,
    isEditMode: false,
    relatedFields: null,
    unrelatedFields: null,
    primaryKey: null,
    data: null,
    item: null,
    fields: null,
  },
  recycleBin: {
    loading: false,
    data: [],
    originalData: [],
  },
  modules: {
    loading: false,
    loaded: false,
    data: [],
  },
  allFolders: [],
  folders: {
    loading: false,
    loaded: false,
    module: {},
    data: [],
  },
  folderModal: {
    loading: false,
    show: false,
    isEdit: false,
    data: {},
  },
  permissionsModal: {
    loading: false,
    show: false,
    data: {},
  },
  moduleModal: {
    loading: false,
    show: false,
    isEdit: false,
    data: {},
  },
  folderData: {
    loading: false,
    data: {},
  },
  moduleData: {
    loading: false,
    data: {},
  },
  tableData: {
    loading: false,
    data: {},
  },
  fieldData: {
    loading: false,
    data: [],
  },
  tables: {
    loaded: false,
    data: {},
  },
  fields: {
    loaded: false,
    data: {},
  },
  table: {
    loading: false,
    loaded: false,
    schema: JSON.parse(JSON.stringify(SCHEMA_INITIAL_DATA)),
    data: [],
    checkedItems: [],
    checkedAll: false,
    isBulkUpdateMode: false,
    pagination: {
      total: 0,
      perPage: 50,
      currentPage: 1,
    },
    row: {},
    relationalModals: {},
    viewModal: {
      loading: false,
      show: false,
      data: [],
    },
    createFilterEditModal: {
      loading: false,
      show: false,
      data: {},
    },
    importModal: {
      show: false,
    },
    importTableViewModal: {
      loading: false,
      show: false,
      items: [],
      fieldDataMap: [],
    },
    views: [],
    validationRules: [],
  },
  todoList: {
    table: {
      loading: false,
      data: [],
      userData: [],
    },
  },
  currentUserPermission: '',
  builder: {
    loading: false,
    loaded: false,
    schema: {},
    tableFieldModal: {
      show: false,
      data: {},
    },
  },
  permissionItemTypes: {
    module: 'module',
    folder: 'folder',
    table: 'table',
    field: 'field',

  },
  permissionObjectData: [],
  fieldTypes: entityUtils.dataTypeOptions, /* [
    {text: 'Text', value: 'text'},
    {text: 'AI Calculation', value: 'ai'},
    {text: 'Whole Number', value: 'wholeNumber'},
    {text: 'Decimal', value: 'decimalNumber'},
    {text: 'Float', value: 'floatNumber'},
    {text: 'Checkbox', value: 'boolean'},
    {text: 'Date', value: 'date'},
    {text: 'DateTime', value: 'dateTime'},
    {text: 'Lookup', value: 'lookup'},
    {text: 'Parent Child Hierarchy', value: 'parentChildHierarchy'},
  ],
  */

  powerAppsEntity: null,
  powerBiReportEntity: null,
  fieldValues: {
    primaryKey: 'primaryKey',
    ai: 'ai',
    text: 'text',
    wholeNumber: 'wholeNumber',
    decimalNumber: 'decimalNumber',
    floatNumber: 'floatNumber',
    boolean: 'boolean',
    dateTime: 'dateTime',
    date: 'date',
    lookup: 'lookup',
    recordStatus: 'recordStatus',
    parentChildHierarchy: 'parentChildHierarchy',
    selectColumn: 'selectColumn',
    createdDate: 'createdDate',
    lastUpdatedDate: 'lastUpdatedDate',
    lastUpdatedBy: 'lastUpdatedBy',
    postedStatus: 'PostedStatus',
    document: 'document',
  },
  filterOptionValues: {
    equal: '=',
    notEqual: '!=',
    less: '<',
    lessOrEqual: '<=',
    greater: '>',
    greaterOrEqual: '>=',
    contains: '*',
    startsWith: '^',
    endsWith: '$',
    notContain: '!*',
    similar: '~',
    from: 'from',
    to: 'to',
  },
  validation: {
    status: '__validationStatus__',
    warnings: '__validationWarnings__',
    validationFailed: 'validationFailed',
    validated: 'validated',
    confirmed: 'confirmed',
    fieldName: '__validationOverrideStatus__',
  },
  permissionTypes: {
    none: 'none',
    deny: 'deny',
    read: 'read',
    write: 'write',
    delete: 'delete',
    post: 'post',
    unpost: 'unpost',
    edit: 'edit',
    admin: 'admin',
  },
  numberFormatTypes: {
    commaSeparated: 'comma',
    dotSeparated: 'dot',
  },
  onlyIcons: [
    'solid',
  ],
  dataManagementModal: {
    show: false,
    loading: false,
  },
  convertMap: {
    map: {},
    fieldTypes: {},
  },
  progressBar: {
    process: 0,
    target: 0,
  },
  todoListModal: {
    loading: false,
    show: false,
    data: [],
  },
  loading: false,
  pagedDataLookupValuesLoading: false,
  allFields: [],
  currentFolder: null,
  orchestration: {
    loaded: false,
    data: [],
  },
  contextMenu: {
    isContextMenuOpen: false,
    contextMenuItemId: null,
  },
  sidebarStructure: null,
  // TODO: store the first fifty lookup options to improve performance and avoid additional calls when switching pagination
  lookupValues: {},
  /** AI Chat Calculation options. */
  fieldOptions: null,
  fieldItemCalculationLoadingState: false,
  /**
   * Data Management Component application-level configuration.
   * - Values expected to be static throughout life of application.
   * - Access via getter. No updates supported.
   * - eg. flags to allow specific features in this instance.
   */
  config: {
  },
  /**
   * Data Management Component application-level control values.
   * - Properties directing components through life of application.
   * - Access via getter. Update via Action.
   * - eg. loading, pagedDataLookupValuesLoading, currentUserPermission.
   */
  control: {
  },
  // State for the view upload history modal
  uploadHistory: {
    loading: false,
    data: [],
    fullUploadData: {},
    page: {
      perPage: 10,
      currentPage: 1,
    },
  },
};

export default STATE;
